import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=f8edb60e&scoped=true&"
import script from "@/views/Groups/Tabs/Profile.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Tabs/Profile.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/Tabs/profile.scss?vue&type=style&index=0&id=f8edb60e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8edb60e",
  null
  
)

export default component.exports